<template>
  <div class="header-tip">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "header-tip"
}
</script>

<style lang="scss" scoped>
.header-tip{
  margin: 5px 0;
  padding: 5px 10px;
  background-color: #f56c6c;
  color: #FFFFFF;
  border-radius: 4px;
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Common/header-tip.vue